import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const UpperSectionAnimation = () => {
  const containers = document.querySelectorAll(".upper-section");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const image = container.querySelectorAll(".upper-section__image");
      const productNameImage = container.querySelectorAll(
        ".product-name-image",
      );
      const text = container.querySelectorAll(".upper-section__text");
      const button = container.querySelectorAll(".upper-section__button .btn");

      if (!text.length && !image.length) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (productNameImage.length) {
        tl.to(productNameImage, base, 0);
      }
      if (text.length) {
        tl.to(text, base, 0.2);
      }

      if (button.length) {
        tl.to(
          button,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
          },
          0.8,
        );
      }

      if (image.length) {
        tl.to(
          image,
          {
            opacity: 1,
            duration: 1,
            ease: "back.out(1.7, 0.5)",
            scale: 1,
          },
          "-=1.2",
        );
      }
    });
  };
  applyAnimations();
};

export default UpperSectionAnimation;
